import styled from 'styled-components';
import { COLOR, TYPOGRAPHY } from '../../../../theme/constants';
import { FlexContainer } from '@emarketer/componentlibrary';

export const ChartActionsContainer = styled(FlexContainer)`
  text-align: center;

  .popper-tooltip {
    color: ${COLOR.WHITE};
    font-size: 14px;
    font-weight: 700;
  }

  .popper-tooltip .png {
    background: ${COLOR.BLACK};
    padding: 12px;
    border-radius: 4px;
  }

  .png + .arrow::after {
    background: ${COLOR.BLACK};
  }

  .popper-tooltip .xls {
    background: ${COLOR.BLACK};
    padding: 12px;
    border-radius: 4px;
  }

  .xls + .arrow::after {
    background: ${COLOR.BLACK};
  }

  @media only screen and (min-width: 1200px) {
    position: absolute;
    left: 565px;
    top: 16px;
  }

  @media only screen and (min-width: 1340px) {
    left: 585px;
  }

  @media (max-width: 1200px) {
    justify-content: start !important;
    max-width: 500px;
    margin: 0 auto;
  }
`;

export const ChartForm = styled.form``;

export const ChartInput = styled.input.attrs((props) => ({
  type: 'text',
}))``;

export const ChartTextArea = styled.textarea``;

export const ChartCanvasLink = styled.a``;

export const ChartDownloadButtonContainer = styled.div<{ disabledButton: boolean }>`
  display: inline-block;
  cursor: pointer;
  width: 210px;

  ${(props) =>
    props.disabledButton
      ? `
    opacity: .5;
    cursor: default;
  `
      : ''}

  @media only screen and (min-width: 1200px) {
    margin-bottom: 10px;
  }

  @media only screen and (min-width: 1340px) {
    display: block;
    margin-bottom: 10px;
    width: 240px;
  }

  @media (max-width: 1200px) {
    margin-right: 10px;
  }
`;

export const ChartDownloadButtonLink = styled.a`
  display: flex;
  align-items: center;
  margin: 0 auto;
  border: 1px solid #e9e9e9;
  padding: 10px 10px;
  color: #337ab7;
  font-size: 14px;

  :hover {
    text-decoration: underline;
  }

  ${TYPOGRAPHY.BOLD};
`;

// The `$` prefix makes `$disabledButton` a styled-components transient prop, meaning it is consumed
// by the styling logic here and never forwarded to the underlying <svg> DOM element.
// Without it, React warns that `disabledButton` is not a valid SVG/HTML attribute.
export const ChartDownloadButtonImage = styled.svg<{ $disabledButton?: boolean }>`
  cursor: pointer;
  ${(props) =>
    props.$disabledButton
      ? `
    opacity: .5;
    cursor: default;
  `
      : ''}
`;
